import React, { useRef, useState } from 'react';
import { capitalize, isEmpty, toLower, startCase } from 'lodash';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import FuseHighlight from 'components/general/FuseHighlight';
import { useFuse } from 'hooks';
import {
  Component,
  SearchBar,
  Search,
  Suggestions,
  Suggestion,
  SuggestionPrimary,
  SuggestionSecondary,
  SuggestionSecondaryText,
  AddButton,
} from './styles';

export default ({
  data,
  placeholder,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
  handleAdd,
  handleModalOpen,
}) => {
  const [active, setActive] = useState(false);
  const suggestionsRef = useRef(null);
  const [suggestionActiveItem, setSuggestionActiveItem] = useState(0);

  const { hits, onSearch } = useFuse(data, {
    includeScore: true,
    includeMatches: true,
    shouldSort: true,
    keys: [...suggestionSecondaryKeys, suggestionPrimaryKey],
    limit: 5,
  });

  const onChange = (e) => {
    setSuggestionActiveItem(0);
    onSearch(e);
  };

  const handleFocus = () => {
    setActive(true);
  };

  const handleClickAway = () => {
    setActive(false);
  };

  const handleKeyPress = ({ keyCode }) => {
    const up = keyCode === 38;
    const down = keyCode === 40;
    const enter = keyCode === 13;
    const { childElementCount, children } = suggestionsRef.current || {};

    setActive(true);

    if (down && suggestionActiveItem < childElementCount) {
      setSuggestionActiveItem(suggestionActiveItem + 1);
    }

    if (up && suggestionActiveItem > 1) {
      setSuggestionActiveItem(suggestionActiveItem - 1);
    }

    if (enter) {
      const selectedElement = children[suggestionActiveItem - 1];
      const suggestionId = selectedElement.getAttribute('data-id');

      handleModalOpen({ id: suggestionId });
      handleClickAway();
    }
  };

  const handleClick = ({ item: { id } }) => {
    handleModalOpen({ id });
  };

  const convertPlaceholder = placeholder.replace('-', ' ');
  let buttonText = startCase(
    toLower(convertPlaceholder.substring(0, convertPlaceholder.length - 1)),
  );

  if (placeholder === 'staff') buttonText = 'Staff';
  if (placeholder === 'bill to') buttonText = 'Bill To';

  return (
    <Component>
      <ClickAwayListener onClickAway={handleClickAway}>
        <SearchBar>
          <SearchIcon />
          <Search
            name="search"
            type="search"
            placeholder={`Search ${placeholder}`}
            onChange={onChange}
            onKeyUp={onSearch}
            onFocus={handleFocus}
            onKeyDown={handleKeyPress}
            autoComplete="off"
          />

          {active && !isEmpty(hits) && (
            <Suggestions ref={suggestionsRef}>
              {hits.map((hit) => {
                const { refIndex, item } = hit;

                return (
                  <Suggestion
                    key={refIndex}
                    suggestionActiveItem={suggestionActiveItem}
                    onClick={() => handleClick(hit)}
                    data-id={item.id}
                  >
                    <SuggestionPrimary>
                      <FuseHighlight
                        hit={hit}
                        attribute={suggestionPrimaryKey}
                      />
                    </SuggestionPrimary>

                    <SuggestionSecondary>
                      {suggestionSecondaryKeys.map((key) => (
                        <SuggestionSecondaryText key={key}>
                          <FuseHighlight hit={hit} attribute={key} />
                        </SuggestionSecondaryText>
                      ))}
                    </SuggestionSecondary>
                  </Suggestion>
                );
              })}
            </Suggestions>
          )}
        </SearchBar>
      </ClickAwayListener>

      <AddButton onClick={handleAdd} startIcon={<AddIcon />} boxShadow>
        Add {buttonText}
      </AddButton>
    </Component>
  );
};
